import { Card } from 'src/components/ui/card';
import { AppAvatar } from 'src/widgets/AppCard';

type Props = {
  app: {
    id: string;
    name?: string | null;
    logoUrl?: string | null;
  };
  title: string;
  description: string;
};

const AppLinkBanner = ({ app, title, description }: Props) => {
  return (
    <Card className="flex gap-3 bg-muted py-3.5 px-4">
      <AppAvatar
        appId={app.id}
        name={app.name ?? 'Untitled Application'}
        claimed
        shape="rounded-square"
        size="sm"
        logoUrl={app.logoUrl ?? undefined}
      />
      <div className="space-y-0.5">
        <h6 className="text-sm font-semibold text-foreground">{title}</h6>
        <p className="text-xs text-muted-foreground">{description}</p>
      </div>
    </Card>
  );
};

export { AppLinkBanner };
